import { Navigate, useSearchParams } from 'react-router-dom';

/** Tidigare /registrera för butik — pekar nu om till partner-sidor eller kundinloggning. */
export const RegisterRedirect = () => {
  const [params] = useSearchParams();
  if (params.get('business') === 'true') {
    return <Navigate to="/bli-partner" replace />;
  }
  return <Navigate to="/logga-in" replace />;
};

export default RegisterRedirect;
